import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import './three-model-viewer.js';
import './timeline-scroll.js';
import './testimonials-carousel.js';
import './features-timeline.js';

import './scroll-animation.js';
import './smooth-scroll.js';

window.Alpine = Alpine;

Alpine.plugin( collapse );

// Setup store for detecting mobile vs desktop
Alpine.store( 'device', {
	isMobile: window.innerWidth < 1024,
} );

// Start Alpine after store is initialized
Alpine.start();

// Add resize listener after Alpine has started
window.addEventListener( 'resize', () => {
	if ( Alpine.store( 'device' ) ) {
		Alpine.store( 'device' ).isMobile = window.innerWidth < 1024;
	}
} );

// Flickity
import Flickity from 'flickity';
import 'flickity-fade';
import 'flickity-bg-lazyload';
import 'flickity-imagesloaded';

document.addEventListener( 'DOMContentLoaded', () => {
	const Hero = document.querySelector( '.flickity-container' );
	if ( Hero ) {
		const flkty = new Flickity( Hero );
	}
} );
